import { render } from 'react-dom'
import App from 'container/App'

import 'simplebar/dist/simplebar.min.css'
import 'styles/index.css'

render(<App />, document.getElementById('app'))
